import { danger } from "./notifications/notify.js";
import { navigate } from "svelte-routing";

import { authToken } from "./stores.js";

import { ApolloClient, HttpLink, ApolloLink, split } from "@apollo/client/core";

// Socket apollo absinthe
import * as AbsintheSocket from "@absinthe/socket";
import { createAbsintheSocketLink } from "@absinthe/socket-apollo-link";
import { Socket as PhoenixSocket } from "phoenix";
import { hasSubscription } from "@jumpn/utils-graphql";

import { InMemoryCache } from "@apollo/client/cache";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

const cache = new InMemoryCache();

const phoenixSocket = new PhoenixSocket("/document_socket", {
  params: () => {
    const token = localStorage.getItem("client-token");
    if (token) {
      return { Authorization: `Bearer ${token}` };
    } else {
      return {};
    }
  },
});

// Wrap the Phoenix socket in an AbsintheSocket.
const absintheSocket = AbsintheSocket.create(phoenixSocket);

// Create an Apollo link from the AbsintheSocket instance.
const absintheSocketLink = createAbsintheSocketLink(absintheSocket);

const httpLink = new HttpLink({
  uri: "/api/gql",
  headers: { "content-type": "application/json" },
});

const link = split(
  (operation) => hasSubscription(operation.query),
  absintheSocketLink,
  httpLink,
);

const errorLink = (errorCallback, networkErrorCallback) =>
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message }) => {
        if (message === "unauthorized") {
          console.log("Auth problem");
          errorCallback();
        } else {
          console.error(graphQLErrors);
        }
      });
    }
    if (networkError) {
      console.log("Network error");
      networkErrorCallback(networkError.toString());
    }
  });

const authLink = (tokenKey) =>
  setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem(tokenKey);
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

const errorCallback = () => {
  authToken.set(null);
  localStorage.removeItem("client-token");
  navigate("/login", { replace: true });
};

const networkErrorCallback = (errorMessage) => {
  danger(`Connections problem:\n${errorMessage}`);
};

export const client = new ApolloClient({
  link: ApolloLink.from([
    errorLink(errorCallback, networkErrorCallback),
    authLink("client-token"),
    link,
  ]),
  cache,
});
